import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { getDeviceType } from "lib/deviceInfo";
import styles from "./WrongPathErrorView.scss";
import classNames from "classnames/bind";
import TXT from "presentational/common/multinational/TXT";

const cx = classNames.bind(styles);

class WrongPathErrorView extends Component {
  render() {
    return (
      <div className={cx("root", getDeviceType())}>
        <div className={cx("title")}>
          <Typography variant="h5" align="center">
            <TXT name="titlePageError" />
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle1" align="center">
            <TXT name="msg_pageError" />
          </Typography>
        </div>
      </div>
    );
  }
}

export default WrongPathErrorView;
